import {useGTMPageView} from '@tnc/shared';
import {useEffect, useState} from 'react';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {Outlet, useLocation} from 'react-router';

import AppProviders from '@/providers/AppProviders';

import Footer from '@/components/common/footer/footer';
import Header from '@/components/common/header/header';
import Switcher from '@/components/common/switcher/switcher';
import Sidebar from '@/components/sidebar';

function AppLayout() {
  const location = useLocation();
  const [MyClassName, setMyClass] = useState('');

  // Track page views
  useGTMPageView(location);

  const BodyClick = () => {
    if (window.innerWidth > 992) {
      if (localStorage.getItem('ynexverticalstyles') === 'icontext') {
        setMyClass('');
      }

      const html = document.documentElement;
      if (html.getAttribute('icon-overlay') === 'open') {
        html.setAttribute('icon-overlay', '');
      }
    }
  };

  useEffect(() => {
    import('preline');
  }, []);

  return (
    <AppProviders>
      <HelmetProvider>
        <Helmet
          htmlAttributes={{
            lang: 'en',
            dir: 'ltr',
            'data-menu-styles': 'dark',
            class: 'light',
            'data-nav-layout': 'vertical',
            'data-header-styles': 'light',
            'data-vertical-style': 'overlay',
            loader: 'disable',
            'data-icon-text': MyClassName,
          }}
        />
        {/* @ts-expect-error - temporary ignore */}
        <Switcher />
        <div className="page">
          <Header />
          <Sidebar />
          <div className="content main-index">
            <div className="main-content" onClick={BodyClick}>
              <Outlet />
            </div>
          </div>
          <Footer />
        </div>
      </HelmetProvider>
    </AppProviders>
  );
}

export default AppLayout;
